<template>
  <div class="event-form-overlay" @click.self="$emit('cancel')">
    <div class="event-form-container">
      <h4><strong>New</strong> Text Schedule</h4>

      <div class="form-card mt-3">
        <div class="form-group">
          <label class="mt-0 rule-label"
            >Schedule Timezone</label
          >
          <input
            v-model="formData.timezone"
            type="text" readonly
            placeholder=""
            class="input-height mt-1"
          />
        </div>
        <aws-cron v-if="!formData.additionPull" v-model="formData.cronText" />
        <div class="form-group" v-if="!formData.additionPull">
          <label class="mt-0 rule-label"
            >Schedule Expression(sample: cron(0 18 ? * * *))</label
          >
          <p class="text-red-400 bg-gray-800 text-align:center">
            Developer Purposes only
          </p>
          <input
            v-model="formData.cronText"
            type="text"
            placeholder=""
            class="input-height mt-1"
          />
        </div>

        <div v-if="formData.additionPull" class="start-end-time-grid">
          <label for="scheduleDate" class="mt-0 rule-label"
            >Select Schedule Date and Time</label
          ><br />
          <div class="regions-grid">
            <div class="region-item">
              <b-form-input
                id="input-1"
                v-model="formData.scheduleDate"
                type="date"
                placeholder="Schedule Date"
                class="input-height"
                required
              ></b-form-input>
            </div>
            <div class="region-item">
              <b-form-input
                id="input-1"
                v-model="formData.scheduleTime"
                type="time"
                placeholder="Schedule Time"
                class="input-height"
                required
              ></b-form-input>
            </div>
          </div>
        </div>

        <div class="form-buttons">
          <button class="btn btn-secondary mr-2" @click="$emit('cancel')">
            Cancel
          </button>
          <button class="btn btn-primary" @click="handleSave">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
import AWSCron from "@/components/report/aws-cron.vue";

function parseTimeToHHmm(value) {
  if (!value) return "";
  if (/^\d{1,2}:\d{2}$/.test(value)) return value;
  const match = value.match(/^(\d{1,2})(?::(\d{2}))?(AM|PM)$/i);
  if (!match) return "";
  let hours = parseInt(match[1]);
  const minutes = match[2] ? parseInt(match[2]) : 0;
  const period = match[3].toUpperCase();
  if (period === "AM") {
    if (hours === 12) hours = 0;
  } else {
    if (hours !== 12) hours += 12;
  }
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}`;
}

export default {
  name: "TextScheduleForm",
  components: {
    "aws-cron": AWSCron
  },
  props: {
    isOverride: Boolean,
    initialData: {
      type: Object,
      default: null
    }
  },
  emits: ["save", "cancel", "error"],
  data() {
    const initial = this.initialData || {};

    // A one-time cron has a specific year (not * or ?) e.g. "cron(0 9 5 APR ? 2026)"
    const monthNameMap = {
      JAN: 1,
      FEB: 2,
      MAR: 3,
      APR: 4,
      MAY: 5,
      JUN: 6,
      JUL: 7,
      AUG: 8,
      SEP: 9,
      OCT: 10,
      NOV: 11,
      DEC: 12
    };

    if (initial.cronText) {
      let raw = initial.cronText.trim();
      if (raw.startsWith("cron(") && raw.endsWith(")")) {
        raw = raw.slice(5, -1);
      }
      const parts = raw.split(" ");
      if (parts.length === 6) {
        const [minute, hour, day, month, , year] = parts;
        const isSpecificYear =
          year && year !== "*" && year !== "?" && !isNaN(year);
        if (isSpecificYear) {
          const resolvedMonth =
            monthNameMap[month.toUpperCase()] ?? parseInt(month);
          const paddedMonth = String(resolvedMonth).padStart(2, "0");
          const paddedDay = String(parseInt(day)).padStart(2, "0");
          const paddedHour = String(parseInt(hour)).padStart(2, "0");
          const paddedMinute = String(parseInt(minute)).padStart(2, "0");
        }
      }
    }

    return {
      cronTextOld: initial.cronText || "",
      formData: {
        id: initial.reportId || initial.id || uuidv4(),
        cronText: initial.cronText || "",
        timezone: initial.timezone ?? "",
        groupName: initial.groupName
      }
    };
  },
  methods: {
    async handleSave() {
      console.log("scheduleDate:", this.formData.scheduleDate);
      console.log("scheduleTime:", this.formData.scheduleTime);

      // Generate cronText from scheduleDate and scheduleTime (AWS EventBridge format)
      if (this.formData.scheduleDate && this.formData.scheduleTime) {
        const date = dayjs(this.formData.scheduleDate);
        const time = this.formData.scheduleTime.split(":");
        const minute = time[1] || "0";
        const hour = time[0] || "0";
        const dayOfMonth = date.date();
        const month = date.month() + 1;
        const year = date.year();
        this.formData.scheduleTime = `${hour}:${minute}`;
        this.formData.scheduleDate = `${year}-${month}-${dayOfMonth}`;
        this.formData.cronText = `cron(${minute} ${hour} ${dayOfMonth} ${month} ? ${year})`;
      }
      await this.genSchedule();
      this.$emit("save", {});
    },
    validateForm() {
      if (this.formData.additionPull) {
        if (!this.formData.scheduleDate) {
          this.$emit("error", "Please select a schedule date");
          return false;
        }
        if (!this.formData.scheduleTime) {
          this.$emit("error", "Please select a schedule time");
          return false;
        }
      } else {
        if (!this.formData.cronText) {
          this.$emit("error", "Please enter a schedule expression");
          return false;
        }
      }

      // Clear any previous errors if validation passes
      return true;
    },
    async genSchedule() {
      const scheduleParams = {
        state: "ENABLED",
        description: this.formData.description,
        scheduleExpression: "",
        groupName: this.formData.groupName,
        input: "",
        timezone: this.formData.timezone
      };
      scheduleParams.input = `{ "uuid": "${this.formData.id}" }`;
      scheduleParams.scheduleExpression = this.formData.cronText;

      console.log(`scheduleParams:`, scheduleParams);
      console.log(`this.initialData:`, this.initialData);

      let response;
      if (this.initialData && this.initialData.scheduleId) {
        scheduleParams.name = this.initialData.scheduleId;
        console.log("schedule name:", scheduleParams.name);
        response = await this.axios.put(
          process.env.VUE_APP_API_ADMIN_API_ENDPOINT + "/order-pull/schedules",
          scheduleParams
        );
      } else {
        console.warn("empty scheduleId");
      }

      if (response && response.status === 200) {
        const message = "Text schedule updated successfully";
        this.$emit("success", message);
      } else {
        const message = `Text schedule updated failed`;
        this.$emit("error", message);
      }
    },
    getDefaultTime() {
      return dayjs()
        .hour(16)
        .minute(0)
        .toDate();
    },
    getDefaultDate() {
      return dayjs().toDate();
    },
    getDateFromTimeStr(time) {
      return dayjs()
        .hour(time.split(":")[0])
        .minute(time.split(":")[1])
        .toDate();
    },
    formatTime(time) {
      const timeObj = dayjs(time, "HH:mm");
      const timeArray = time.split(":");
      if (timeArray[1] === "00") {
        return timeObj.format("hA");
      } else {
        return timeObj.format("h:mmA");
      }
    }
  }
};
</script>

<style scoped>
/* Event form modal */
.event-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.event-form-container {
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  width: 1000px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-control:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-card {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.report-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}

.input-height {
  height: 38px;
}

.upper {
  text-transform: uppercase;
}

.report-type-name-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr 1fr !important;
  gap: 15px !important;
}

.report-type-col,
.report-name-col {
  min-width: 0 !important;
}

@media (max-width: 575px) {
  .report-type-name-grid {
    grid-template-columns: 1fr !important;
  }
}

.start-end-time-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 15px !important;
}

.start-time-col,
.end-time-col {
  min-width: 0 !important;
}

@media (max-width: 575px) {
  .start-end-time-grid {
    grid-template-columns: 1fr !important;
  }
}

.consolidate-sort-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 15px !important;
}

.consolidate-col,
.sort-col {
  min-width: 0 !important;
}

@media (max-width: 575px) {
  .consolidate-sort-grid {
    grid-template-columns: 1fr !important;
  }
}

.additional-report-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr 1fr !important;
  gap: 15px !important;
}

.additional-type-col,
.additional-name-col,
.additional-file-col {
  min-width: 0 !important;
}

@media (max-width: 768px) {
  .additional-report-grid {
    grid-template-columns: 1fr !important;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .additional-report-grid {
    grid-template-columns: 1fr 1fr !important;
  }
}

.regions-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 16px 0;
}

.region-item {
  display: flex;
  align-items: flex-start;
}

.region-checkbox {
  display: flex;
  align-items: center;
  height: 20px;
}

.checkbox-input {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid #d1d5db;
  cursor: pointer;
}

.checkbox-input:checked {
  background-color: #4f46e5;
  border-color: #4f46e5;
}

.checkbox-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.region-label {
  margin-left: 12px;
  font-size: 14px;
}

.checkbox-label {
  font-weight: 500;
  color: #374151;
  cursor: pointer;
}

@media (max-width: 768px) {
  .regions-grid {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .regions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.report-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 15px !important;
}

.report-col {
  min-width: 0 !important;
}

.card {
  margin: 0px;
  border-radius: 0px !important;
}
</style>
